import styles from './RefineRadio.less';
import React, { Component, PropTypes } from 'react';
import RefineRadioItem from './RefineRadioItem/RefineRadioItem';

export default class RefineRadio extends Component {

  static propTypes = {
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        isActive: PropTypes.bool.isRequired,
        refineParams: PropTypes.object
      })
    ).isRequired,
    multiSelect: PropTypes.bool,
    path: PropTypes.string.isRequired,
    labelledBy: PropTypes.string.isRequired,
    handleSelection: PropTypes.func,
    preNavigationAction: PropTypes.func
  };

  static defaultProps = {
    multiSelect: false
  };

  render() {
    const { options, multiSelect, path, labelledBy, handleSelection, preNavigationAction, ...restProps } = this.props;

    const id = `${labelledBy}__radiogroup`;
    const ariaRole = multiSelect ? {} : { role: 'radiogroup' };

    return (
      <ul {...restProps} id={id} className={styles.root} aria-labelledby={labelledBy} {...ariaRole}>
        {
          options.map(option => {
            const itemProps = {
              multiSelect,
              path,
              handleSelection,
              preNavigationAction,
              labelledBy: id
            };

            return (
              <RefineRadioItem key={option.value} {...option} {...itemProps} />
            );
          })
        }
      </ul>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/Search/components/RefineBar/components/RefineRadio/RefineRadio.js
 **/